import { Component, OnInit, OnDestroy/* , ViewChild */ } from '@angular/core';
import { Product } from '../../shared/classes/product';
import { Router } from '@angular/router';
import { ProductService } from '../../shared/services/product.service';
import { ApiService } from '../../shared/services/api.service';
import { LocationService } from '../../shared/services/location.service';
import { RESULT, RESPONSE, DB, AppInfo } from '../../shared/services/env.service';
import { ConfigApp/* , TypeOrder */ } from '../../shared/services/config-app';
import { EitPlace } from '../../shared/classes/eitplace';
// import { GooglePlaceDirective } from 'ngx-google-places-autocomplete';
// import { Address } from 'ngx-google-places-autocomplete/objects/address';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NcivicoComponent } from '../../shared/components/modal/ncivico/ncivico.component';
import { AppService } from '../../shared/services/app.service';
import { ToastrService } from 'ngx-toastr';
import { RestaurantService } from '../../shared/services/restaurant.service';

declare const google: any;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, OnDestroy {

  // @ViewChild("placesRef") placesRef : GooglePlaceDirective;

  query: string = "";
  places: any = [];
  location: any;
  geocoder: any;
  coords: any = {lat: AppInfo.LATITUDE, lng: AppInfo.LONGITUDE}
  options: any = { componentRestrictions: { country: 'IT' }, types: ['geocode'] };
  sliders: any = {items: []};
  promo: any = [];
  defaultSlider: any = {items: []}; 
  bgUrl: string = "assets/images/new/header.jpg"

  appData: any = null;
  numServices: number = 0;
  typeDom: number = 0;
  typeAsp: number = 0;
  typeTav: number = 0;
  services: Array<any> = []
  service: number = 0;

  products: Product[] = [];
  ProductSliderConfig: any = {loop: false, dots: false, nav: false, navSpeed: 300, responsive: {991: {items: 3}, 767: {items: 3}, 420: {items: 3}, 0: {items: 3}}};

  constructor(private router: Router, public api: ApiService, public config: ConfigApp, public productService: ProductService, 
              private restService: RestaurantService, private modalService: NgbModal,  private locService: LocationService, 
              private toastService: ToastrService, private appService: AppService) {
    this.productService.getProducts.subscribe(response => 
      this.products = response.filter(item => item.type == 'gym')
    );
    
    /*this.service = TypeOrder.EIT_DOMICILIO;
    localStorage.setItem("service", ""+TypeOrder.EIT_DOMICILIO);*/
    this.service = 0;
    localStorage.setItem("service", ""+0);
 
    this.location = new EitPlace();
    this.location.initData();

    this.locService.location.subscribe(x => {
      if (x) {
        this.location = x;
        if (x.description) {
          this.query = this.location.description;
          this.coords.lat = this.location.latitude
          this.coords.lng = this.location.longitude
        }
      }
    });
  }


  ngOnInit(): void {
    // Change color for this layout
    document.documentElement.style.setProperty('--theme-gradient1', '#01effc');
    document.documentElement.style.setProperty('--theme-gradient2', '#485ff2');

    this.geocoder = new google.maps.Geocoder;

    this.initData();
  }

  ngOnDestroy(): void {
    // Remove Color
    document.documentElement.style.removeProperty('--theme-deafult');
    document.documentElement.style.removeProperty('--theme-gradient1');
    document.documentElement.style.removeProperty('--theme-gradient2');
  }

  initData() {
    this.appService.appObs.subscribe(x => {  
      this.appData = x;
      console.log(this.appData)
      this.numServices = this.appService.countServices(this.appData);
      this.typeDom = this.appService.typeDomicilio(this.appData);
      this.typeAsp = this.appService.typeAsporto(this.appData);
      this.typeTav = this.appService.typeTavoli(this.appData);
      if(this.typeDom > 0) this.services.push({id: 0, title: "Domicilio", image: 'assets/images/Icone/domicilio.svg'})
      if(this.typeAsp > 0) this.services.push({id: 1, title: "Asporto", image: 'assets/images/Icone/asporto.svg'})
      if(this.typeTav > 0) this.services.push({id: 2, title: "Prenota", image: 'assets/images/Icone/tavolo.svg'})
    });
    //this.initSlider();
  }

  initSlider() {
    this.sliders = this.defaultSlider;
    if (this.location != undefined && this.location != "undefined" && this.location != null && this.location != "null") {
      this.api.postj("home/mediaslider", this.location).subscribe(res => {
        if (res[RESPONSE.JP_STATUS] == RESPONSE.JPS_OK) {
          if(res[RESPONSE.JP_RESULT].length > 0) {
            this.sliders.items = [];
            this.sliders.items = res[RESPONSE.JP_RESULT];
          }
          else this.sliders.items = this.defaultSlider.items;
        } 
        else if (res[RESPONSE.JP_STATUS] == RESPONSE.JPS_ERROR && res[RESPONSE.JP_MSG]) this.sliders.items = this.defaultSlider.items;
        else {
          console.log(res);
          this.sliders.items = this.defaultSlider.items;
        }
      }, err => {
        console.log(err);
        this.sliders.items = this.defaultSlider.items;
      });
    }    
  }

  public searchenter() {
    console.log("searchenter");
    if (!this.geocoder) this.geocoder = new google.maps.Geocoder();
    if (this.query.length > 0) {
      this.locService.selectAddress(this.geocoder, this.location, this.query, true);
      this.query = this.location.description;
      this.locService.nextLocation(this.location);
      this.coords.lat = this.location.latitude
      this.coords.lng = this.location.longitude
    }
  }

  public handleAddressChange(address: any/* Address */) {
    console.log("handle address Change");
    if (!this.geocoder) this.geocoder = new google.maps.Geocoder();
    console.log(address)
    this.locService.selectPlace(this.geocoder, this.location, address).then(res => {
      this.location = res;
      this.query = res.description;
      this.locService.nextLocation(this.location);
      this.coords.lat = this.location.latitude
      this.coords.lng = this.location.longitude
    });
  }

  getPosition(): void{

    if (navigator.geolocation) {

      navigator.geolocation.getCurrentPosition((position: any) => { 
        this.locService.selectPlaceFromPosition(this.geocoder, this.location, position).then(res => {

          this.location = res;
          this.query = res.description;
    
          this.locService.nextLocation(this.location);
          if (this.locService.isDeliveryOk(null)) {
            //this.locService.loadDelivery_R(true);
          }
    
          if (this.locService.isTakeAwayOk(null)) {
            //this.locService.loadTakeAway_R(true);
          }
    
    
        //  this.viewScroller.scrollToPosition([0, window.innerHeight]);
        });

      })
    }else {
      console.log("No support for geolocation")
   }
   /* if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position)=>{
          if (!this.geocoder) this.geocoder = new google.maps.Geocoder();
          let latlng = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
          
          this.geocoder.geocode({latLng: latlng}, (results: any, status: any) => {
            if (status === 'OK' && results[0] && results[0].geometry && results[0].geometry.location) {
              this.locService.setLocationInfoFromNative(this.location, results[0], position.coords.latitude, position.coords.longitude);
              this.query = this.location.description;
              this.locService.nextLocation(this.location);
              this.coords.lat = this.location.latitude
              this.coords.lng = this.location.longitude
            }
          })
        });
    } else {
       console.log("No support for geolocation")
    }*/
  }

  onGo (type: number){
    switch(type){
      case -1: this.goListRest(); break;
      case  0: this.goDlvRest(); break;
      case  1: this.goTakeRest(); break;
      case  2: this.goTblRest(); break;
    }
  }

  checkAddress(){
    this.locService.location.subscribe(location => {
      if (location) {
        if(this.appData.count_domicilio == 1 && this.appData.count_restaurants > 1) location.id_rest = this.appData.ids_domicilio [0]
        this.locService.checkAddressHome(location).subscribe(res => {
          if (res[RESPONSE.JP_STATUS] == RESPONSE.JPS_OK) {
            let restaurant = res[RESPONSE.JP_RESULT]
            localStorage.setItem(DB.ACTIVITY_BASE, JSON.stringify(restaurant));
            this.router.navigate(['/ristoranti/' + restaurant.slug], { queryParams: { } });
          }
          else this.toastService.error("Il ristorante non consegna all'indirizzo indicato!");
        });
      }
    });
  }

  goListRest() {
    console.log("golistrest");
    //var result = this.service == TypeOrder.EIT_DOMICILIO ? this.locService.isDeliveryOk(null) : this.locService.isTakeAwayOk(null)//RESULT.RESULT_OK;
    var result =  this.locService.isDeliveryOk(null) ;
    if(result == RESULT.RESULT_OK) {
      this.router.navigate(['/restaurant/list'], { queryParams: { } });
    }
    else if(result == RESULT.RESULT_ERROR_CIVICO) this.selectCivico()
    else this.toastService.error("Inserisci l'indirizzo completo");
  }

  goDlvRest() {
    console.log("godlvrest");
    var result = this.locService.isDeliveryOk(null);
    if(result == RESULT.RESULT_OK) {
      if(this.appData.count_domicilio > 1) this.router.navigate(['/restaurant/delivery'], { queryParams: { } });
      else this.checkAddress();
    }
    else if(result == RESULT.RESULT_ERROR_CIVICO) this.selectCivico()
  }

  goTblRest()  {
    console.log("gotblrest");
    var result = this.locService.isTablesOk(null);
    if(result == RESULT.RESULT_OK) this.router.navigate(['/restaurant/tables'], { queryParams: { } });
  }

  goTakeRest() {
    console.log("gotakerest");
    if(this.appData.count_asporto > 1){
      this.router.navigate(['/restaurant/takeaway'], { queryParams: { } });
    }
    else{
      //devo prendere le info del ristorante    
      let data: any = {}  
      if(this.appData.count_asporto == 1 && this.appData.count_restaurants > 1) data.id_rest = this.appData.ids_asporto [0]
      this.api.postj("restaurant/recordtakeaway", data, "").subscribe(res => {
        console.log(res);  
        if (res[RESPONSE.JP_STATUS] == RESPONSE.JPS_OK && res[RESPONSE.JP_RESULT]) {    
          let rest = res[RESPONSE.JP_RESULT]
          localStorage.setItem(DB.ACTIVITY_BASE, JSON.stringify(rest));
          this.restService.loadList(rest.menu.id);
          this.router.navigate(['/ristoranti/asporto/' + rest.slug_takeaway]);
        }
        else {
          console.log(res);
          this.toastService.error(res[RESPONSE.JP_MSG]);
        }
      }, (err) => {
        console.log(err);
      });
    }
  }

  selectCivico(){
    let modal = this.modalService.open(NcivicoComponent,  { size: 'md', centered: true, ariaLabelledBy: 'Ncivico-Modal',  backdrop: 'static'})
    modal.componentInstance.onDismiss.subscribe((event: any) => {
      if(event.status == RESPONSE.JPS_OK && event.result){
        this.location.num = event.result
        this.location.numForced = event.result;
        this.location.description = this.locService.getAddressFromPlace(this.location);
        this.locService.selectAddress(this.geocoder, this.location, this.location.description, true);
        this.query = this.location.description;
        this.coords.lat = this.location.latitude
        this.coords.lng = this.location.longitude
      }
    })
  }

}
